import { useEffect, useState } from "react";
import { default as FingerprintJS } from "@fingerprintjs/fingerprintjs";
import { errorMessage } from "../utils/errorMessage";

export function useGetBrowserFingerPrint() {
  const [visitorId, setVisitorId] = useState(() =>
    sessionStorage.getItem("visitorId"),
  );
  const [errMessage, setErrMessage] = useState(null);
  const [retryCount, setRetryCount] = useState(1);
  const MAX_RETRY_ATTEMPTS = 3;
  const RETRY_INTERVAL_MS = 30000;

  const generateFingerprint = async () => {
    try {
      // If it already exists, don't regenerate
      const existing = sessionStorage.getItem("visitorId");
      if (existing) {
        setVisitorId(existing);
        return;
      }

      const fp = await FingerprintJS.load();
      const result = await fp.get();

      setVisitorId(result.visitorId);
      sessionStorage.setItem("visitorId", result.visitorId);
      setErrMessage(null);
    } catch (error) {
      console.log(
        `Failed to generate visitorId. Retrying (${retryCount}/${MAX_RETRY_ATTEMPTS})...`,
      );
      const { message } = errorMessage(error);
      setErrMessage(message);
      setRetryCount((prev) => prev + 1); // ✅ avoid stale state
    }
  };

  useEffect(() => {
    if (visitorId) return; // ✅ already generated

    let timeoutId;

    if (retryCount === 1) {
      generateFingerprint();
    } else if (retryCount <= MAX_RETRY_ATTEMPTS) {
      timeoutId = setTimeout(() => {
        generateFingerprint();
      }, RETRY_INTERVAL_MS);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId); // ✅ cleanup
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retryCount, visitorId]);

  return { visitorId, errMessage };
}
